module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('am-topbar', {
    staticClass: "header-topbar",
    attrs: {
      "inverse": "inverse",
      "container": "container",
      "fixed": "top"
    }
  }, [_c('h1', {
    staticClass: "am-topbar-brand",
    slot: "brand"
  }, [_c('a', {
    attrs: {
      "href": "/amazevue"
    }
  }, [_vm._v("Amazevue")])]), _c('am-nav', {
    staticClass: "am-topbar-nav",
    attrs: {
      "mode": "pills"
    },
    model: {
      value: (_vm.topbarNav),
      callback: function($$v) {
        _vm.topbarNav = $$v
      },
      expression: "topbarNav"
    }
  }), _c('div', {
    staticClass: "am-topbar-right"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7abe6f26"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=jade!./~/vue-loader/lib/selector.js?type=template&index=0!./doc/components/MainHeader.vue
// module id = 86
// module chunks = 2